import Vue from "vue";
import Vuex from "vuex";
import common from "./common";
import search from "./search";
import player from "./player";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    common,
    search,
    player
  },
});
